import { Injectable } from '@angular/core';
import { LoginResponse } from '../models/auth.model';


@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly JWT_TOKEN = 'access_token';
  private readonly REFRESH_TOKEN = 'refresh_token';
  private readonly TOKEN_TYPE = 'token_type';

  
  getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }
  getTokenType() {
    return localStorage.getItem(this.TOKEN_TYPE);
  }
  getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }
  
  storeTokens(tokens: LoginResponse) {
    localStorage.setItem(this.JWT_TOKEN, tokens.access_token);
    localStorage.setItem(this.TOKEN_TYPE, tokens.token_type);
    if(tokens.refresh_token){
      localStorage.setItem(this.REFRESH_TOKEN, tokens.refresh_token);
    }
  }

  removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.TOKEN_TYPE);
    localStorage.removeItem(this.REFRESH_TOKEN);
  }

  isLoggedIn() {
    return !!this.getJwtToken();
  }
}
